<template>
    <div>
        <div class="no-print">
            <h1>Skriv ut lastbäraretiketter</h1>
            <b-card class="mt-3 mb-3" v-if="labels.length == 0">
                <b-card-header>
                    Skapa lastbäraretiketter
                </b-card-header>
                 <b-card-text>
                    <!-- <loadcarrierlabel loadcarrierid="343473873"></loadcarrierlabel> -->
                    Ange antal lastbärare att skapa och skriva ut: <br />
                    <b-input type="number" v-model="numLabels" style="width: 100px;"></b-input>
                    <b-button variant="primary" @click="createLabels()">Skapa</b-button>
                    <b-spinner v-if="isBusy" label="Skapar..."></b-spinner>
                </b-card-text>
            </b-card>
        </div>
        <b-card-header class="no-print" v-if="labels.length > 0">
            <!-- <h1>Följesedelsvisare</h1> -->
            <b-button variant="primary" @click="printNormal">
                <i class="fa-solid fa-print"></i>
                Skriv ut</b-button>
            &nbsp;
            Antal: {{ labels.length }}
        </b-card-header>
        <b-card-body>
            <div ref="pdfContent" id="pdf-content" class="pdf-content do-print">
                <div class="pdf-page-break" v-for="(lb, i) in labels" :key="i">                    
                    <loadcarrierlabel :loadcarrierid="lb"></loadcarrierlabel>
                    <div class="no-print text-center"
                        style="background-color: gray; border-radius: 4px; border: 2px solid #ccc; padding: 10px; margin-top: 2px;">
                        <!-- <i>Ny sida</i> -->
                    </div>
                </div>
            </div>
        </b-card-body>
    </div>
</template>
<script>
import { BButton } from 'bootstrap-vue';
import { Api } from "../../lib/api";
import LoadCarrierLabel from './loadcarrierlabel.vue';
const api = new Api();

export default {
    name: "loadcarrierlabellist",
    data() {
        return {
            isBusy: false,
            labels: [],
            numLabels: 100
        };
    },
    components: {
        'loadcarrierlabel': LoadCarrierLabel,
        'b-button': BButton
    },
    methods: {
        createLabels() {
            if (this.isBusy)
                return; // Förhindra flera samtidiga skapandeprocesser    

            this.isBusy = true;
            // Skapa etiketter baserat på numLabels      
            if (this.numLabels < 1 || this.numLabels > 500) {
                alert("Ange ett giltigt antal lastbärare att skapa (1-500).");
                return;
            }
            this.labels = [];

            api.post('/api/sodexo/GenerateLoadCarriers?count=' + this.numLabels).then((res) => {
                if (res.errMsg) {
                    alert("Ett fel inträffade: " + res.errMsg);
                    this.isBusy = false;
                    return;
                }
                if (res.data) {
                    this.labels = res.data.loadCarrierIds;
                }
                this.isBusy = false;
            });

        },
        printNormal() {
            window.print();
        },
    },
};

</script>
<style scoped>
.pdf-page-break {
  page-break-after: always;
}

 @media print {
      /* .do-print {
        display: block;
      } */

      .no-print {
        display: none;
      }

      .page-break {
        page-break-before: always;
      }

      @page {
        margin: 20mm;
      }
    }
</style>